var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['spacer', _vm.params.size].join(' '),style:({
    background: _vm.params.background,
  })},[(_vm.componentIndex === _vm.activeComponent)?_c('RemoveItem',{nativeOn:{"click":function($event){return _vm.removeComponent(_vm.componentIndex)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }